import Client from './Client';

export const ApiKeysApi = {
    list: async (page, filter = '') => {
        return await Client.get(`/v1/api-keys?page=${page}&filter=${filter}`);
    },
    store: async (data) => {
        return await Client.post('/v1/api-keys', data);
    },
    update: async (id, data) => {
        return await Client.put(`/v1/api-keys/${id}`, data);
    },
    delete: async (id) => {
        return await Client.destroy(`/v1/api-keys/${id}`);
    },
    regenerateToken: async (id) => {
        return await Client.post(`/v1/api-keys/${id}/regenerate`);
    },
    searchStations: async (search) => {
        return await Client.get(`/v1/api-keys/stations/search?search=${encodeURIComponent(search)}`);
    },
};

export default ApiKeysApi;
